var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class QuestionLayout {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get availableLayouts() {
        if (this.question.context.app.solidEdit.editLayout.whichLayoutsToShow === 'compatible') {
            return this.question.context.app.solidEdit.editLayout.microLayouts.filter(info => info.name.startsWith(`Questiontype_${this.question.questionType}_layout`));
        }
        return this.question.context.app.solidEdit.editLayout.microLayouts;
    }
    get layoutBundle() {
        return this.question.model.stream.bundle[this.question.layout];
    }
    get globalLayoutBundle() {
        return this.question.context.app.model.stream.bundle[this.question.layout];
    }
    get layoutName() {
        if (!this.layoutBundle) {
            return '';
        }
        return this.layoutBundle.name.split('_').slice(2).join('_');
    }
    get layoutShortName() {
        return this.layoutName.split('_').slice(-1)[0];
    }
    get layoutDescription() {
        if (!this.layoutBundle) {
            return '(ungültig)';
        }
        return this.layoutBundle.description;
    }
    get layoutId() {
        if (!this.layoutBundle) {
            return '(ungültig)';
        }
        return this.layoutBundle.id_string;
    }
    get isAbfragerLayout() {
        return this.layoutName.includes('Abfrager');
    }
}
__decorate([
    computed
], QuestionLayout.prototype, "availableLayouts", null);
__decorate([
    computed
], QuestionLayout.prototype, "layoutBundle", null);
__decorate([
    computed
], QuestionLayout.prototype, "globalLayoutBundle", null);
__decorate([
    computed
], QuestionLayout.prototype, "layoutName", null);
